import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosHandler from "./axiosHandler";

export const getAllTemplates = createAsyncThunk(
  "template/getAllAppraisalTemplateDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/template/getAllAppraisalTemplateDetails`
      );
      return response?.data.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getTemplatesByDeptId = createAsyncThunk(
  "template/getTemplatesByDeptId",
  async (deptId, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/template/getTemplateListByDeptId/${deptId}`
      );
      return response?.data.data;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);


export const getTemplateDetailsById = createAsyncThunk(
  "template/getTemplateDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/template/getAppraisalTemplateDetailsById/${id}`
      );
      if (response?.data?.data) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const getTemplatesByUserId = createAsyncThunk(
  "template/getTemplatesByUserId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.get(
        `/template/getTemplatesByUser/${id}`
      );
      if (response) {
        return response?.data?.data;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const createTemplate = createAsyncThunk(
  "template/createTemplate",
  async ({ editId, data }, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.post(`/template/create`, data);
      const responsedata = {
        editId: editId,
        data: response?.data?.data,
      };

      return responsedata;
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "template/deleteTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHandler.delete(
        `/template/deleteAppraisalTemplateById/${id}`
      );
      if (response?.status === 200) {
        return id;
      }
    } catch (error) {
      return throwError(error, rejectWithValue);
    }
  }
);

const throwError = (error, rejectWithValue) => {
  return rejectWithValue(
    error?.response?.data || "An error occurred"
  );
};
